(() => {
  const qs  = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const dialog = qs("#otumaMenuOverlay");

  // =========================
  // 1) SHUFFLE (GLOBAL)
  // =========================
  function shuffleText(el) {
    const original = el.dataset.otumaOriginal || el.textContent;
    el.dataset.otumaOriginal = original;

    const chars = original.split("");
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyzáéíóúÁÉÍÓÚñÑ";
    let t = 0;

    const interval = setInterval(() => {
      t++;
      el.textContent = chars
        .map((c) => {
          if (c === " " || c === "+") return c;
          return t < 6 && Math.random() < 0.6
            ? letters[(Math.random() * letters.length) | 0]
            : c;
        })
        .join("");

      if (t >= 6) {
        clearInterval(interval);
        el.textContent = original;
      }
    }, 28);
  }

  function bindShuffle(root = document) {
    qsa("[data-otuma-shuffle] .otuma-menu__text", root).forEach((textEl) => {
      if (textEl.dataset.otumaShuffleBound === "1") return;
      textEl.dataset.otumaShuffleBound = "1";

      const trigger = textEl.closest("[data-otuma-shuffle]") || textEl;
      trigger.addEventListener("mouseenter", () => shuffleText(textEl));
      trigger.addEventListener("focus", () => shuffleText(textEl));
    });

    qsa("[data-otuma-shuffle]", root).forEach((a) => {
      if (a.querySelector(".otuma-menu__text")) return;
      if (a.dataset.otumaShuffleBound === "1") return;
      a.dataset.otumaShuffleBound = "1";
      a.addEventListener("mouseenter", () => shuffleText(a));
      a.addEventListener("focus", () => shuffleText(a));
    });
  }

  bindShuffle(document);

  // =========================
  // 2) OVERLAY MENU
  // =========================
  if (!dialog) return;
  if (dialog.dataset.otumaBound === "1") return;
  dialog.dataset.otumaBound = "1";

  const OPEN_MS  = 340;
  const CLOSE_MS = 340;

  const lockScroll = (lock) => {
    document.documentElement.classList.toggle("otuma-scroll-lock", lock);
    document.body.classList.toggle("otuma-scroll-lock", lock);
  };

  const isOpen = () => dialog.hasAttribute("open");

  const openMenu = () => {
    if (isOpen()) return;

    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "open");

    lockScroll(true);
    requestAnimationFrame(() => {
      dialog.setAttribute("data-state", "open");
      if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
    });

    bindShuffle(dialog);
  };

  const closeMenu = () => {
  if (!isOpen()) return;

  const ap = qs("[data-otuma-account-popover]", dialog);
  if (ap) ap.hidden = true;

  dialog.setAttribute("data-state", "closed");

  window.setTimeout(() => {
    try {
      if (typeof dialog.close === "function") dialog.close();
    } catch (_) {}
    dialog.removeAttribute("open");
    lockScroll(false); // <- FORZAR aquí también
    dialog.removeAttribute("data-state");
  }, CLOSE_MS);
};


  // Open triggers
  qsa("[data-otuma-menu-open]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openMenu();
    });
  });

  // Close triggers
  qsa("[data-otuma-menu-close]", dialog).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      closeMenu();
    });
  });

  // Click en backdrop (fuera del panel) cierra overlay
  dialog.addEventListener("click", (e) => {
    const panel = qs(".otuma-menu__panel", dialog);
    if (!panel) return;

    // si clickeas dentro del panel, NO cierres overlay (punto)
    if (panel.contains(e.target)) return;

    closeMenu();
  });
  



  // ESC
  dialog.addEventListener("cancel", (e) => {
    e.preventDefault();
    closeMenu();
  });

  dialog.addEventListener("close", () => {
    lockScroll(false);
    dialog.removeAttribute("data-state");
    dialog.removeAttribute("open");
  });

  // Navegación SOLO links dentro del panel
  // (si el link está dentro del panel, cerramos overlay y navegamos)
  dialog.addEventListener("click", (e) => {
  const a = e.target.closest("a[href]");
  if (!a) return;

  if (a.closest("[data-otuma-account-popover]")) return;

  const panel = dialog.querySelector(".otuma-menu__panel");
  if (!panel || !panel.contains(a)) return;

  const href = a.getAttribute("href");
  if (!href || href === "#" || href.startsWith("javascript:")) return;

  if (a.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

  e.preventDefault();
  e.stopPropagation();

  closeMenu();
  window.setTimeout(() => window.location.assign(href), CLOSE_MS);
}, true);


 // ===== Proxies (Buscar / Carrito)
  qsa("[data-otuma-proxy]", dialog).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const target = btn.getAttribute("data-otuma-proxy");
      closeMenu();

      window.setTimeout(() => {
        if (target === "cart") {
          if (window.otumaCartDrawer && typeof window.otumaCartDrawer.open === "function") {
            window.otumaCartDrawer.open();
          } else {
            window.location.assign("/cart");
          }
        }

        if (target === "search") {
          const searchTrigger =
            document.querySelector('button[aria-label*="Search"]') ||
            document.querySelector('button[aria-label*="Buscar"]') ||
            document.querySelector('a[href*="/search"]');
          if (searchTrigger) searchTrigger.click();
        }
      }, CLOSE_MS + 80);
    });
  });

  // ===== Search modal trigger desde el menú
  qsa("[data-otuma-search-open]", dialog).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
      setTimeout(() => {
        const searchBtn = document.querySelector(".otuma-hdr__icon-btn[data-otuma-search-open]");
        if (searchBtn) searchBtn.click();
      }, CLOSE_MS);
    });
  });

})();

// =========================
// ACCOUNT POPOVERS (delegated)
// =========================
(() => {
  const qs = (s, r=document) => r.querySelector(s);
  const qsa = (s, r=document) => Array.from(r.querySelectorAll(s));

  const dialog = qs("#otumaMenuOverlay");

  const isInsideOverlay = (el) => !!el.closest("#otumaMenuOverlay");
  const getWrap = (el) => el.closest("[data-otuma-account]");
  const getPop  = (wrap) => wrap?.querySelector("[data-otuma-account-popover]");

  const closeAll = (scope) => {
    // scope: "overlay" | "outside" | "all"
    const all = qsa("[data-otuma-account-popover]");
    all.forEach((pop) => {
      const inOverlay = isInsideOverlay(pop);
      if (scope === "all") pop.hidden = true;
      if (scope === "overlay" && inOverlay) pop.hidden = true;
      if (scope === "outside" && !inOverlay) pop.hidden = true;
    });
  };

  // Un solo handler en CAPTURE para ganar a cualquier script del tema
  document.addEventListener("click", (e) => {
    const toggle = e.target.closest("[data-otuma-account-toggle]");
    const pop    = e.target.closest("[data-otuma-account-popover]");
    const wrap   = e.target.closest("[data-otuma-account]");

    // 1) Click en toggle => toggle (y cierra otros en el mismo scope)
    if (toggle) {
      const w = getWrap(toggle);
      const p = getPop(w);
      if (!p) return;

      const scope = isInsideOverlay(w) ? "overlay" : "outside";
      closeAll(scope);

      e.preventDefault();
      p.hidden = !p.hidden;
      return;
    }

    // 2) Click dentro del popover => NO cierres nada (deja que el link navegue)
    if (pop) return;

    // 3) Click dentro del wrapper cuenta (pero no toggle/popover) => no cierres
    if (wrap) return;

    // 4) Click fuera => cierra ambos scopes
    closeAll("all");
  }, true);

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll("all");
  });
})();
